import React from 'react';
import { TagMultiSelect } from '../../../components/forms/TagMultiSelect';

interface TagInputProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  suggestions?: string[];
  isDisabled?: boolean;
}

/**
 * Per-track tag editor used on TrackDetailPage. Thin wrapper around the shared
 * `TagMultiSelect` with the FR-017 defaults (allowCreate=true, maxTags=20,
 * wrapped in FormControl with the existing "Tags" label).
 */
export const TagInput: React.FC<TagInputProps> = ({ tags, onChange, suggestions = [], isDisabled = false }) => (
  <TagMultiSelect
    value={tags}
    onChange={onChange}
    suggestions={suggestions}
    allowCreate
    maxTags={20}
    isDisabled={isDisabled}
    wrapInFormControl
  />
);
